
<div [class.row]="!isVideocallStarted" [class.col]="isVideocallStarted">

  <!-- Procedure progress -->
  <app-scotty-card
    *ngIf="
      assistance.status != 3 &&
      assistance.maintenance &&
      assistance.maintenance.procedure &&
      assistance.maintenance.isSupportRequired"
    [title]="assistance.maintenance.task ? assistance.maintenance.task.name : assistance.maintenance.procedure.name"
    [fullHeight]="true"
    [hideDivisor]="true"
    [class.fullscreen]="isFullscreen">
    <app-timeline
      *ngIf="progress else loading"
      [groups]="progress"
      [canEdit]="true"
      (onUpdate)="onStepExecutionUpdate($event)"
    ></app-timeline>
  </app-scotty-card>

  <!-- Live chat -->
  <mat-card class="card" [ngStyle]="{height: progress && isVideocallStarted ? '50%' : ''}">
    <tlm-chat
      [user]="getUser()"
      [ticket]="getTicket()"
      [equipment]="assistance.equipment?.model"
      [autosendVideocallRequest]="autostartVideocall()"
      [welcomeMessage]="welcomeMessage"
    ></tlm-chat>
    <button *ngIf="canClose" mat-raised-button color="warn" class="close-maintenance" [class.close-maintenance-right]="isVideocallStarted" (click)="closeAssistance()">{{ ('Close ' + closeLabel) | translate }}</button>
  </mat-card>

</div>

<!-- Videocall module -->
<!-- Switch module based on container -->
<div *ngIf="isVideocallStarted && versionInUse == 0" style="background-color: black; width: calc(50% - 30px); margin: 15px; border-radius: 15px;">
  <div [ngStyle]="{ color: 'white', textAlign: 'center', marginTop: '20%' }">Waiting for remote peer...</div>
</div>
<app-videocall
  *ngIf="isVideocallStarted && versionInUse == 1"
  [companyId]="accountManagerService.account.company.id"
  [equipment]="assistance.equipment?.model"
  [assistance]="assistance"
  [assistanceType]="assistanceType"
  [canEditScene]="canEditScene"
  [canRecord]="canRecord"
  (onPreparationCompleted)="enterVideocall()"
  (onVideocallClosed)="isVideocallStarted = false"
></app-videocall>
<app-videocall-v2
  *ngIf="isVideocallStarted && versionInUse == 2"
  [companyId]="accountManagerService.account.company.id"
  [equipment]="assistance.equipment?.model"
  [assistance]="assistance"
  [assistanceType]="assistanceType"
  [canEditScene]="canEditScene"
  [canRecord]="canRecord"
  [mode]="mode"
  (onModuleLoaded)="enterVideocall()"
  (onDisconnected)="closeVideocall()"
  (onRemotePeerDisconnected)="closeVideocall(true)"
  (onFullscreenChanged)="isFullscreen = $event"
></app-videocall-v2>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
